<app-banner [heading]="'DIRECTOR\'S MESSAGE'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= Features Section ======= -->
    <section id="features" class="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
            <img src="/assets/img/message/1.jpeg" class="img-fluid" alt="">
          </div>
          <div class="col-lg-6 wow fadeInUp pt-5 pt-lg-0" style="visibility: visible; animation-name: fadeInUp;">
            <h4>From the Desk of our Director</h4>
            <p>
              “To quote Kalpana Chawla, the famous astronaut:<br><br>
			  Dive Deep Down, An Aim Awaits Pearls Peep, for your hands to reach<br>
			  Just yours I for you!<br>
			  Just yours I for you!<br>
			  Decades and Ages<br>
			  A Pearl in the Shell<br>
			  A Secret in the Brain<br>
			  OPEN IT, BREAK IT, REVEAL IT<br><br>

			  Wishing you to realise your full potential and become global minded inquirers, Tagore Global 
			  blends the opportunities and options of the premier largest school with intimate, caring and
			  dynamic environment.<br> 
			  
            </p>
			
          </div>
		  <div class="col-lg-12 wow fadeInUp pt-5 pt-lg-0" style="visibility: visible; animation-name: fadeInUp;">
            
            <p>
              It is heartening to see its growing enrollment due to its recognition as
			  a launching pad for selections of our alumni in various prestigious institutions year after 
			  year. Each one of you have the potential to excel. You can make each day of your life a
			  masterpiece by good decisions and discipline, the two sides of the same coin- Goal getting 
			  and Goal setting. <br><br>Good decision minus daily discipline and daily discipline without good 
			  decision is only regimental life without reward. Good decision coupled with daily discipline 
			  results into a masterpiece of potential.)<br><br>
			  With a Mission of Happy Learning!		
			</p>
			
			
			<p><strong>K.L.Watta</strong><br>
             Managing Director<br>
			</p>
          </div>
        </div>
      </div>
    </section><!-- End Features Section -->
	
	
	
    
    
  </main>